import React from 'react';
import Image1 from "../Assets/Professional Travel Solutions.png"
import Image2 from "../Assets/presenting-banner-bg.jpg"
import Image3 from "../Assets/Transparent Pricing.png"
import Image4 from "../Assets/Easy Booking Options.png"

const TejasToursFeatures = () => {
  const features = [
    {
      image: Image1,
      title: "Professional Travel Solutions",
      description: "Streamlined travel services tailored for Bangalore travelers."
    },
    {
      image: Image2,
      title: "Extensive Vehicle Network",
      description: "Large fleet of cars and buses for all your needs."
    },
    {
      image: Image3,
      title: "Transparent Pricing",
      description: "Clear costs and availability with no hidden fees."
    },
    {
      image: Image4,
      title: "Easy Booking Options",
      description: "Simple reservations for regional and outstation trips."
    }
  ];

  return (
    <div className="w-full bg-gray-100 py-10 px-4">
      <div className="max-w-5xl mx-auto">
        {/* Header - Smaller */}
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-6">
          Why Choose Urbania Nava Cabs?
        </h1>

        {/* Features Grid - Tighter */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow transition-shadow border border-gray-100"
            >
              {/* Image - Smaller */}
              <div className="w-full h-40 overflow-hidden">
                <img 
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content - Smaller Padding */}
              <div className="p-4">
                <h3 className="text-base font-bold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-xs leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TejasToursFeatures;